/* eslint-disable max-len */
import React, { useCallback } from 'react';
import { BoardLiteData } from '../../../../api/ApiTypes';
import { usePrompt } from '../../../../ui';
import { FlexScroller } from '../../../../ui/Scrollers';
import { useResolve } from '../../../Container';
import { Popup, PopupProps } from '../../../popups/Popup';
import { WorkspaceModel } from '../../Models';
import { SimpleBoardListView } from '../../boards/SimpleBoardListView';
import { Flexer } from '../../elements/LayoutElements';

type OnComplete = (board: BoardLiteData | false) => void;

const BoardSelectForm = ({ onComplete }: { onComplete: OnComplete }) => {
    const workspace = useResolve(WorkspaceModel);
    return <Flexer grow flex margin="-.5">
        <FlexScroller autoHide={false}>
            <Flexer padding=".5">
                <SimpleBoardListView workspaceId={workspace.id} onSelect={onComplete} />
            </Flexer>
        </FlexScroller>
    </Flexer>;
};

export const boardSelectPopup = () => ({ ui: BoardSelectPopup });

export const BoardSelectPopup = ({ action, dismiss }: PopupProps) => {

    const onComplete = useCallback((board: BoardLiteData | false) => {
        if (board) {
            action(board);
        }
        else {
            dismiss();
        }
    }, [action, dismiss]);

    const promptRef = usePrompt({ ignoreEnter: true, onAction: dismiss });

    return <Popup ref={promptRef} w={90} h={60}>
        <Popup.Header>
            <Popup.Title>
                Select a board
            </Popup.Title>
        </Popup.Header>
        <Flexer height={1} />
        <Popup.Content>
            <BoardSelectForm onComplete={onComplete} />
        </Popup.Content>
        <Popup.Close onAction={dismiss} />
    </Popup>;
};
